import React from "react";
import InputMask from "react-input-mask";

const MaskInput: React.FC<any> = (props) => {
  return (
    <InputMask autoComplete="off" {...props} className="ant-input"></InputMask>
  );
};

export default MaskInput;
